// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/sass/style.scss
// module id = 1
// module chunks = 0